import { SET_GLOBAL_MAIN_PERIOD } from '../actions/datePeriod'
import { SET_AUDIT_GLOBAL_PERIOD } from '../actions/audit'
import { SET_COMMON_GLOBAL_PERIOD } from '../actions/analytics'

// libraries
import moment from "moment";

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

// functions
const getStartDate = () => {
    const endDate = new Date();
    const startDate = new Date();

    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);

    return [moment(startDate).format(DATE_FORMAT), moment(endDate).format(DATE_FORMAT)];
};

const state = {
    globalMainPeriod: getStartDate(),
    mainPeriod: getStartDate(),
};

const getters = {
    getGlobalMainPeriod: state => state.globalMainPeriod,
    getMainPeriod: state => state.mainPeriod,
};

const actions = {
    [SET_GLOBAL_MAIN_PERIOD]: ({commit, dispatch}, payload) => {
        commit(SET_GLOBAL_MAIN_PERIOD, payload);

        dispatch(SET_AUDIT_GLOBAL_PERIOD, payload)
        dispatch(SET_COMMON_GLOBAL_PERIOD, payload)
    },
};

const mutations = {
    [SET_GLOBAL_MAIN_PERIOD]: (state, payload) => {
        state.globalMainPeriod = payload.period;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};